import axios from 'axios';
import authAxios from '../common/authAxios';
import Constants from '../common/constants';

const BASE = `${Constants.API_BASE_URL}/ads`;

const advertisementService = {
	// ── Публичный ──────────────────────────────────────────────────────────────
	getDisplayData: () => axios.get(BASE, { withCredentials: false }),

	// ── Только для ADMIN / MODERATOR ───────────────────────────────────────────
	getAllForAdmin: () => authAxios.get(`${BASE}/admin/videos`),

	createVideo: (data) => authAxios.post(`${BASE}/video`, data),
	updateVideo: (id, data) => authAxios.put(`${BASE}/video/${id}`, data),
	deleteVideo: (id) => authAxios.delete(`${BASE}/video/${id}`),

	getSettings: () => authAxios.get(`${BASE}/settings`),
	updateSettings: (data) => authAxios.put(`${BASE}/settings`, data),
};

export default advertisementService;
